import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
	// 登录
	login: {
		Welcome: 'Welcome',
		correct: 'Please enter the correct email address',
		enter: 'Please enter the password',
		Sign: 'Sign in',
		Forgot: 'Forgot password',
		Create: 'Create an Account',
		Password: 'Please enter your password',
		Welcome_to_TOZO: 'Welcome to TOZO',
		email: 'Please enter email address',
		agree: ' * I agree to',
		Agreement: 'User Agreement',
		see: '. Please see our',
		Policy: 'Privacy Policy',
		here: ' here.',
		Account: 'Create Account',
		account: 'Or continue with your social account',
		email_placeholder: 'Please enter your account number or email',
		email_required: 'Please enter your account number or email',
		email_correct: 'please fill in Correct email address',
		password_required: 'please fill in password',
		login_fail: 'login fail',
		error_4000: 'The application name cannot be empty or the link does not exist',
		error_4006: 'Sorry, The verification code you entered is incorrect',
		error_4008: 'Sorry, The email address has been registered',
		error_4009: 'Sorry, The account you entered does not exist',
		error_4010: 'Sorry, The account password you entered is incorrect',
	},
	// 注册
	register: {
		register_title: 'Registered Account',
		email_placeholder: 'Please enter your email',
		code_placeholder: 'Please enter verification code',
		get: 'Get',
		countdownTips: 'The verification code is valid for ten minutes',
		password_placeholder: 'Please enter password',
		confirm_password_placeholder: 'Please enter confirm password',
		regulation: "Password must contain 8-16characters and be a combination of at least two of the following: digits, letters, or symbols.",
		agree_text1: "I've read and agree to",
		agree_text2: 'Account Use Agreement,Account Privacy Statement',
		register_btn: 'Register',
		agree_required: 'Need to check agreement',
		password_required: 'Please confirm password',
		confirmed_and_password_correct: 'Confirmed password is different with password filled in first',
		email_required: 'Please enter email account',
		email_correct: 'DaEmail format errorte',
		code_required: 'Please enter verification code',
		password_required_js: 'Please enter password',
		password_correct: 'password length should be between 8 and 16 characters',
		registered: 'This mailbox has been registered',
		email_format: 'Email address format is incorrect',
		account_required: 'Account is required',
		email_information: 'The verification code was sent successfully. Please pay attention to the email information',
		register_successfully: 'TOZO account was register successfully'
	},
	// 重置密码
	reset: {
		reset_title: "Reset Password",
		old_password_placeholder: 'Please enter your old password',
		new_password_placeholder: 'Please enter your new password',
		password_confirmation: 'Please enter your new password again',
		reset_btn: 'Reset',
		reconfirm_new_password: 'Please reconfirm new password',
		new_password_verify: 'The new password entered twice is inconsistent with the new password',
		password_format: 'The length should be between 8 and 16 characters',
		password_changed_successfully: 'Password changed successfully',
	},
	// 忘记密码
	forgot: {
		forgot_title: "Find your password",
		email_placeholder: 'Please enter your email',
		code_placeholder: 'Please enter verification code',
		get: 'Get',
		countdownTips: 'The verification code is valid for ten minutes',
		password_placeholder: 'Please enter new password',
		confirm_password_placeholder: 'Please enter confirm new password',
		submit_btn: 'SUBMIT',
		password_required: 'Please confirm new password',
		confirmed_and_password_correct: 'Confirmed password is different with password filled in first',
		email_required: 'Please enter email account',
		email_correct: 'Please enter the correct email format',
		code_required: 'Please enter verification code',
		password_required_js: 'Please enter new password',
		password_correct: 'password length should be between 8 and 16 characters',
		email_information: 'The verification code was sent successfully. Please pay attention to the email information',
		email_verify: 'Please enter your email',
		forgot_successfully: 'Password modified successfully'
	},
	// 404
	page_404: {
		SORRY: "SORRY!",
		reserved: "All rights reserved",
		check_text: "Please check that the URL you entered is correct, or click the button below to return to the homepage.",
		Back_Home: "Back to Home",
		Get_Support: "Get Support",
		message: "Sorry, you cannot access this page..."
	},
	// 导航栏
	nav_box: {
		title: {
			NEW_RELEASES: "NEW RELEASES",
			HEADPHONES: "HEADPHONES",
			WATCHES: "WATCHES",
			SPEAKERS: "SPEAKERS",
			HOT_SALE: "HOT_SALE",
			MID_YEAR_SALE: "MID-YEAR SALE",
			GAME_DEALS: "GAME DEALS",
			HALLOWEEN_SALE: "HALLOWEEN SALE",
			BLACK_FRIDAY: "BLACK FRIDAY",
			CYBER_MONDAY: "CYBER MONDAY",
			DEALS: "DEALS",
			CHRISTMAS_SALE: "CHRISTMAS SALE",
			HOLIDAY_SALE: "HOLIDAY SALE",
			SOUND_DEALS: "SOUND DEALS",
			VALENTINE_S_DAY: "VALENTINE'S DAY",
			TOZO_COUPON: "TOZO COUPON",
			ST_PATRICK_S_DAY: "ST. PATRICK'S DAY",
			SPRING_SALE: "SPRING SALE",
			EASTER_SALE: "EASTER SALE",
			EARTH_DAY_SALE: "EARTH DAY SALE",
			MOTHERS_DAY_SALE: "MOTHER'S DAY SALE",
			FATHERS_DAY: "FATHER'S DAY",
			INDEPENDENCE_DAY: "INDEPENDENCE DAY",
			PRIME_DAY: "PRIME DAY",
			SUMMER_SALE: "SUMMER SALE",
			BACK_TO_SCHOOL: "BACK TO SCHOOL",
			NEW_YEAR_SALE: "NEW YEAR SALE",
			SUMMER_DEALS: "SUMMER DEALS",
			SUPPORT: "SUPPORT",
			EXPLORE: "EXPLORE"
		},
		NEW_RELEASES: {
			Shop_All_New_Releases: "Shop All New Releases"
		},
		HEADPHONES: {
			EARBUDS: "EARBUDS",
			OPEN_EAR: "OPEN-EAR",
			OVER_EAR: "OVER-EAR",
			Active_Noise_Cancelling: "Active Noise Cancelling",
			Fitness: "Fitness",
			Wireless_Charging: "Wireless Charging",
			Hi_Res_Audio: "Hi-Res Audio",
			Premium_Call_Quality: "Premium Call Quality",
			Gaming: "Gaming",
			Waterproof_Earbuds: "Waterproof Earbuds",
			Translate_Earbuds: "Translate Earbuds",
			Shop_All_Headphones: "Shop All Headphones",
			FILTERING: "FILTERING",
		},
		WATCHES: {
			Shop_All_Watches: "Shop All Watches"
		},
		SPEAKERS: {
			Shop_All_Speakers: "Shop All Speakers"
		},
		SUPPORT: {
			SERVICES: "SERVICES",
			Support_Center: "Support Center",
			Process_Warranty: "Process Warranty",
			Order_Tracker: "Order Tracker",
			Privacy_Center: "Privacy Center",
			Contact_Us: "Contact Us",
			FAQs: "FAQs",
			Support_Videos: "Support Videos",
			Manuals: "Manuals",
			Warranty_Info: "Warranty Info"
		},
		EXPLORE: {
			ACTIVITIES: "ACTIVITIES",
			CES_2026: "CES 2026",
			CES_2025: "CES 2025",
			CES_2024: "CES 2024",
			NC20_Available: "NC20 Available",
			NC20_Pro_Coming: "NC20 Pro Coming",
			TOZO_Coupon: "TOZO Coupon",
			BLACK_FRIDAY: "BLACK FRIDAY",
			CYBER_MONDAY: "CYBER MONDAY",
			CHRISTMAS_SALE: "CHRISTMAS SALE",
			PROMOTION: "PROMOTION",
			HOT_SALE: "HOT SALE",
			Halloween_Sale: "Halloween Sale",
			HOLIDAY_SALE: 'HOLIDAY SALE',
			SOUND_DEALS: "SOUND DEALS",
			VALENTINE_S_DAY: "VALENTINE'S DAY",
			SPRING_SALE: "SPRING SALE",
			EASTER_SALE: "EASTER SALE",
			HT3_Coming_Soon: "HT3 Coming Soon",
			EARTH_DAY_SALE: "EARTH DAY SALE",
			MOTHERS_DAY_SALE: "MOTHER'S DAY SALE",
			TOZOAiryEar: "TOZOAiryEar",
			ST_PATRICK_S_DAY: "ST. PATRICK'S DAY",
			FATHERS_DAY: "FATHER'S DAY",
			INDEPENDENCE_DAY: "INDEPENDENCE DAY",
			PRIME_DAY: "PRIME DAY",
			SUMMER_SALE: "SUMMER SALE",
			Back_To_School: "Back To School",
			CLUB: "CLUB",
			Blog: "Blog",
			Forum: "Forum",
			BRAND: "BRAND",
			Our_Story: "Our Story",
			Technology: "Technology",
			TOZO_FOR_BUSINESS: "TOZO FOR BUSINESS",
			Dealer_Store: "Dealer Store",
			TOZO_Distrbutor_Portal: "TOZO DISTRBUTOR PORTAL",
			Become_a_Distribution_Partner: "Become a Distribution Partner"
		},
		Account: {
			SIGN_IN: 'SIGN IN',
			My_account: 'My account',
			Sign_out: 'Sign out',
		},
	},
	// 首页
	homePage:{
		banner: {
			Welcome: 'Welcome to TOZO Community',
		},
		nav: {
			Home: 'Home',
			Followers_list: 'Followers list',
			Fans_list: 'Fans list',
			Personal: 'Personal',
			Messages: 'Messages',
		},
	},
	// 帖子
	postsArr:{
		Recommand: 'Recommand',
		Following: 'Following',
		Say_something: 'Say something?',
		Submit: 'Submit',
		Follow: 'Follow',
		Not_interested: 'Not interested',
		Don_t_like_the_author: "Don't like the author",
		Report: 'Report',
		Cancel: 'Cancel',
		Pin: 'Pin',
		Unpin: 'Unpin',
		Delete: 'Delete',
		Cancel: 'Cancel',
	},
	// 关注
	FollowersArr:{
		Followers: 'Followers',
		Search_for_followers: 'Search for Followers',
	},
	// 粉丝
	FansArr:{
		Fans: 'Fans',
		Search_for_fans: 'Search for fans',
	},
	// 个人中心
	PersonalArr:{
		Likes: 'Likes',
		Followers: 'Followers',
		Fans: 'Fans',
		Posts : 'Posts',
		Media : 'Media',
		Edit : 'Edit',
	},
	// 消息
	MessagesArr:{
		Comment: 'Comment',
		Likes: 'Likes',
		New_Fans: 'New Fans',
		Comment_you : ' Comment you',
		Liked_your_comment : 'Liked your comment',
		Liked_your_post : 'Liked your post',
		Followed_you: "Followed you.",
		Comment_title:"Comment",
		Reply_title:"Reply",
		Reply:"Reply",
		View:"View",
		Replies_title: 'Replies',
		replies:"replies",
	},
	// 评论
	CommentList:{
		Heat: 'Heat',
		Time: 'Time',
		Reply: 'Reply',
		Delete: 'Delete',
		Copy: 'Copy',
		Cancel: 'Cancel',
	},
	// 搜索
	SearchUserArr:{
		more_users: 'Please enter nickname',
		Who_to_follow : 'Who to follow',
	},
	// 举报
	postreportArr:{
		page_title: 'Report',
		report_title: 'Please select the report type',
		remark_placeholder: 'Please describe your specific problem here',
		select_report_type: 'Please select the report type',
		remark_max_length : 'The description of the problem can be within 500 characters.',
		validate_all: 'Please check the required fields',
		reportList:{
			Spam_and_Abuse: 'Spam and Abuse', //垃圾信息和滥用行为
			Pornographic: 'Pornographic and indecent content', //色情和不雅内容
			False_Information: 'False Information', //虚假信息
			Intellectual: 'Intellectual Property Infringement', //知识产权侵权
			Personal_safety: 'Personal safety and threats', //身安全和威胁
			Hate_Speech: 'Hate Speech', //仇恨言论
			suicide_content: 'Self-harm or suicide content', //自残或自杀内容
			Account_theft: 'Account theft or fraud', //盗号或欺诈
			Impersonating_someone_else: 'Impersonating someone else', //冒充他人身份
			Harassment_Report: 'Harassment Report', //骚扰举报
			Invasion_of_Privacy: 'Invasion of Privacy', //侵犯隐私
			Malware_or_links: 'Malware or links', //恶意软件或链接
			Other: 'Other', //其他
		}
	},
	// 编辑个人信息
	EditPersonalInformation:{
		page_title: "Edit Personal Information",
		placeholder:{
			nickname: "Please enter the nickname",
			country: "Please select your country/region",
			gender: "Please select your gender",
			year: "Select year",
			month: "Select month",
			date: "Select date",
		},
		genderList:{
			male: "male",
			female: "female",
			other: "other",
		},
		rules:{
			nickname_required: "Please enter a nickname",
			nickname_length: "Nickname must be between 1 and 50 characters",
			avatar_required: "Please upload your profile picture",
			bg_img_required: "Please upload your homepage background image",
		}
	},
	// 提示框
	ConfirmPrompt:{
		delete_tips: 'Are you sure you want to delete?',
		Your_login: 'Your login has expired, please log in again',
		experience_more: 'Please log in to experience more interesting things',
		Login_Tips: 'Login Tips',
	},
	// 图片轮播
	SwiperArr:{
		Live: 'Live',
	},
	// 接口提示
	tipsArr:{
		Send_successfully: 'Send successfully',
		Feedback_success: 'Feedback success',
		Edited_success: 'Edited successfully',
		Disliked_user: 'Disliked user ID cannot be empty',
		System_Error: 'System Error',
		reported_post: 'You have already reported this post',
		user_info_required_fields: 'Please check and fill in the required fields',
		network_request: 'The network request does not exist',
		
	},
	// 按钮
	buttonArr:{
		Submit: 'Submit',
		Follow: 'Follow',
		Unfollow: 'Unfollow',
		Edit: 'Edit',
		Cancel: 'Cancel',
		Confirm: 'Confirm',
		Send: 'Send',
		Save: 'Save',
	},
	// 无数据提示
	noDataArr:{
		interesting_things: 'Please log in to experience more interesting things',
		No_data_yet: 'No data yet',
		follow_list: "You haven't followed anyone yet",
		fan_home_page: 'Publish interesting content to attract more people to follow you',
		message: 'No message data',
		comment_module: 'No comment data',
		likes_module: 'No likes data yet',
		comment_replies_list: 'No comment reply information',
		new_fan_follow_list: 'No new fans data',
		search_user: 'No related recommendations',
		go_login: 'Go Login',
	},
	// 时间转化
	timeArr:{
		Just_now: 'Just now',
		minute_ago: 'minute ago',
		hour_ago: 'hour ago',
		Yesterday: 'Yesterday',
		days_ago: 'days ago',
	},
	// 文件上传提示
	FileUploadArr:{
		image_formats: 'The formats of uploaded image files only support ',
		image_size: 'The uploaded image size cannot exceed ',
		image_max_text: 'You can only upload up to',
		image_files: 'image files',
		
		video_formats: 'The uploaded video file format only supports ',
		video_size: 'The uploaded video file size cannot exceed ',
		video_max_text: 'You can only upload up to',
		video_files: 'video files',
		
		avatar_image_formats: 'The uploaded avatar image file format only supports ',
		avatar_image_size: 'The maximum file size for uploaded avatar images is ',
		avatar_max_text: 'You can only upload up to',
		avatar_files: 'avatar image files.',
		
		background_image_formats: 'The uploaded background image file format only supports ',
		background_image_size: 'The maximum file size for uploaded background images is ',
		background_max_text: 'You can only upload up to',
		background_files: 'background image files.',
	},
	loading: "loading",
	...enLocale
}

export default en
